<div class="notify-template-form-dialog ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'notifyTemplates.createNewTemplate'|translate}}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="dialog-content-wrapper">
            <div class="template-form">
                <upsc-notify-template-form (formValueChanged)="onFormValuesChanged($event)"
                                           (templateCreated)="onTemplateCreated($event)"></upsc-notify-template-form>
            </div>
            <div class="divider vertical"></div>
            <div class="template-preview">
                <h3 class="template-preview-title">{{ templateTitle }}</h3>
                <upsc-notify-template-preview [template]="template"></upsc-notify-template-preview>
            </div>
        </div>
    </mat-dialog-content>
</div>
